import { render, staticRenderFns } from "./ApprovalJournal.vue?vue&type=template&id=ce8ffe66"
import script from "./ApprovalJournal.vue?vue&type=script&lang=js"
export * from "./ApprovalJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports